import React from "react";
import { Box } from "@mui/material";
import { ensureNamespacesLoadedSync } from "../../i18n/lazyNamespaces";
import TeamTasksRoutes from "../TeamTasks";
import { POPUP_TEAM_BASE } from "../../utils/teamNavigation";

ensureNamespacesLoadedSync(["teamTasks", "team", "teamAgenda"]);

const TeamTasksPopup = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <TeamTasksRoutes basePath={POPUP_TEAM_BASE} standalone />
    </Box>
  );
};

export default TeamTasksPopup;
